import { render } from "./AddonModules.vue?vue&type=template&id=5dc0d33a&scoped=true"
import script from "./AddonModules.vue?vue&type=script&lang=js"
export * from "./AddonModules.vue?vue&type=script&lang=js"

import "./AddonModules.vue?vue&type=style&index=0&id=5dc0d33a&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc0d33a"]])

export default __exports__